import { HTMLAttributes, ReactNode } from 'react';
import { BasicComponentProps, ObjectValues } from '@stadionhq-v3/core';

export const MATCH_RESULT = {
  WIN: 'Win',
  DRAW: 'Draw',
  LOSS: 'Loss',
} as const;

export type Result = ObjectValues<typeof MATCH_RESULT>;

export type MatchResult = {
  id: number;
  result: Result;
};

export type CombinedFormGuideProps = BasicComponentProps & {
  homeTeamCrest: ReactNode;
  awayTeamCrest: ReactNode;
  homeTeamName: string;
  awayTeamName: string;
  formLabel: string;
  winAbbreviated: string;
  lossAbbreviated: string;
  drawAbbreviated: string;
  positionHeading: string;
  homeTeamLeaguePosition: string;
  awayTeamLeaguePosition: string;
  playedHeading: string;
  homeTeamLeaguePlayed: string;
  awayTeamLeaguePlayed: string;
  pointsHeading: string;
  homeTeamLeaguePoints: string;
  awayTeamLeaguePoints: string;
  homeTeamResults?: MatchResult[];
  awayTeamResults?: MatchResult[];
  showLeagueStats?: boolean;
  primaryTeam?: 'away' | 'home';
  nativeProps?: HTMLAttributes<HTMLDivElement>;
};
